import { render, staticRenderFns } from "./hzcontact.vue?vue&type=template&id=648f98b6&scoped=true"
import script from "./hzcontact.vue?vue&type=script&lang=js"
export * from "./hzcontact.vue?vue&type=script&lang=js"
import style0 from "./hzcontact.vue?vue&type=style&index=0&id=648f98b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f98b6",
  null
  
)

export default component.exports